import * as z from "zod/v4";

export const findPreviousReturnShippingRefunds = {
  name: "findPreviousReturnShippingRefunds" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({ hasPreviousShippingRefund: z.boolean() }),
};
